import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPlant: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getScreens: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/userLock/v1/plants/${plantCd}/screens`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getControlList: ({ plantCd, scrId, scrName, userId, onlyIng, currentPage, pageUnit }) => {
		return client
			.get(
				`${BASE_URL}/userLock/v1/plants/${plantCd}/userControls?scrId=${scrId}&scrName=${scrName}&userId=${userId}&onlyIng=${onlyIng}&currentPage=${currentPage}&pageUnit=${pageUnit}`
			)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	postControl: ({ plantCd }, controlList) => {
		return client
			.post(`${BASE_URL}/userLock/v1/status/2/plants/${plantCd}/controlRelease`, controlList)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
